import styled from "styled-components";

export const LockedPageContainer = styled.div`
    position: relative;
    width: 100%;
    height: 100vh;
    overflow: hidden;
    padding-top: 65px;
`;

export const BannerOverlay = styled.div`
    position: sticky;
    top: 70px;
    z-index: 10;
    height: 0;
`;
